{
    "Accessibility menu": "Menu dostępności",
    "Close": "Zamknij",
    "Content adjustments": "Dostosowania treści",
    "Navigation adjustments": "Dostosowania nawigacji",
    "Text Align": "Wyrównanie tekstu",
    "Align Left": "Wyrównaj do lewej",
    "Align Center": "Wyśrodkuj",
    "Align Right": "Wyrównaj do prawej",
    "Adjust Font Size": "Dostosuj rozmiar czcionki",
    "Highlight Title": "Podświetl tytuł",
    "Highlight Links": "Podświetl linki",
    "Readable Font": "Czytelna czcionka",
    "Colour adjustments": "Dostosowania kolorów",
    "Dark Contrast": "Ciemny kontrast",
    "Light Contrast": "Jasny kontrast",
    "High Contrast": "Wysoki kontrast",
    "High Saturation": "Wysokie nasycenie",
    "Low Saturation": "Niskie nasycenie",
    "Monochrome": "Monochromatyczny",
    "Tools": "Narzędzia",
    "Reading Guide": "Przewodnik czytania",
    "Big Cursor": "Duży kursor",
    "Increase Font Size": "Zwiększ rozmiar czcionki",
    "Decrease Font Size": "Zmniejsz rozmiar czcionki",
    "Letter Spacing": "Odstęp liter",
    "Line Height": "Wysokość linii",
    "Font Weight": "Grubość czcionki",
    "Dyslexia Font": "Czcionka dla dysleksji",
    "Language": "Język",
    "Accessibility widget": "Otwórz menu dostępności",
    "Accessibility Profiles": "Profile dostępności",
    "Cognitive Disability": "Niepełnosprawność poznawcza",
    "Seizure Safe": "Bezpieczny do stosowania podczas napadów",
    "Accessibility statement": "Oświadczenie o dostępności",
    "ADHD": "ADHD",
    "Low Vision": "Słabowzroczność",
    "Pause Animations": "Zatrzymaj animacje",
    "Animation paused": "Animacja wstrzymana",
    "Reset all settings": "Resetuj ustawienia",
    "Shortcut:": "Skrót:",
    "Epilepsy Safe Mode": "Tryb bezpieczny dla osób z padaczką",
    "Mute sounds": "Wycisz dźwięki",
    "Page read": "Strona przeczytana",
    "Page read controls": "Sterowanie czytaniem strony",
    "Pause": "Wstrzymaj",
    "Resume": "Wznów",
    "Stop": "Zatrzymaj",
    "Settings": "Ustawienia",
    "Speed": "Prędkość",
    "Voice": "Głos",
    "Close accessibility menu": "Zamknij menu dostępności",
    "Back to accessibility menu": "Powrót do menu dostępności",
    "Search languages": "Szukaj języków",
    "Selected language": "Wybrany język",
    "View accessibility statement (opens in new window)": "Zobacz oświadczenie o dostępności (otwiera się w nowym oknie)",
    "Visit CookieYes website (opens in new window)": "Odwiedź stronę CookieYes (otwiera się w nowym oknie)",
    "Reset all accessibility settings to default": "Przywróć domyślne ustawienia dostępności"
}
